var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CallCenterForm',{attrs:{"action-on-save":function (callCenter) { return _vm.editCallCenter(callCenter); },"editable-call-center":_vm.editableCallCenter}})}
var staticRenderFns = []

export { render, staticRenderFns }